import { render } from "./QaTask.vue?vue&type=template&id=2a70dcd8&scoped=true"
import script from "./QaTask.vue?vue&type=script&lang=js"
export * from "./QaTask.vue?vue&type=script&lang=js"

import "./QaTask.vue?vue&type=style&index=0&id=2a70dcd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a70dcd8"]])

export default __exports__